import { IInternalApis } from "./IInternalApis"
import IAccountData, { WatchmenMembership } from "../../interfaces/watchmen"
import ApiUtils from "../ApiUtils"
import { IPatientVital } from "../../interfaces/patient/IPatientVitals"
import { IOngoingDoctorConsultation } from "../../interfaces/ongoingConsultation/IOngoingDoctorConsultation"
import { ConsultationStatusConstant } from "../../constants"
import IPlanStaticData from "../../interfaces/api/internal/IPlanStaticData"
import { ICoachConsultation } from "../../interfaces/ongoingConsultation/ICoachConsultationData"
import { ICreateCachedOdinTicketPayload, ICreateCachedOdinTicketResponse } from "../../interfaces/api/internal/createCachedOdinTicket"

const InternalApiUrls = {
	account: "/account",
	getCurrentTime: "/internal/utils/current-time",
	staticData: "/internal/static/fetch",
	patientVitals: (userId: number, patientId: number, metricIds: number[]) => `/internal/patient-vitals?userId=${userId}&subUserId=${patientId}&metricIds=${metricIds}`,
	getMembershipsForUser: (userId: string, userIdType: string) => `/internal/utils/memberships?userId=${userId}&userIdType=${userIdType}`,
	doctorOngoingConsultationData: (appointmentId: number) => `/internal/consultation/cached-doctor-fetch?appointmentId=${appointmentId}`,
	fetchPastPrescriptions: (patientId: number, userId: number) => `/internal/consultation/past-prescriptions?patientId=${patientId}&userId=${userId}`,
	requestPdfGeneration: "/internal/pdf/request-generation",
	requestCgmReportPdfGeneration: "/internal/pdf/request-cgm-pdf-generation",
	planStaticDataUrl: "/internal/static/plan-data",
	getCurrentVersion: "/internal/app-version",
	coachOngoingConsultationDate: (patientId: number, userId: number, appointmentId: number, isSelf: boolean, isPackInfoRequired: boolean) =>
		`/internal/coach-consult?patientId=${patientId}&userId=${userId}&appointmentId=${appointmentId}&isSelf=${isSelf}&isPackInfoRequired=${isPackInfoRequired}`,
	deleteCachedCoachConsultationData: (consultationId: number) => `/internal/consultation/coach-consult-draft-delete?consultationId=${consultationId}`,
	saveCoachConsultationDataToRedis: `/internal/consultation/coach-consult-draft`,
	uploadMediaChunk: "/internal/media-upload",
	downloadAndUploadFile: "/internal/download-and-upload-file",
	createCachedOdinTicket: "/internal/odin/create-cache",
}
// const planStaticDataUrl: string = "/orion/static";
// const unsavedPrescriptionUrl: string = "/orion/prescription/getUnsavedPrescription?consultationId=$appointmentId";
// const savePrescriptionUrl: string = "/orion/prescription/savePrescription";
// const removePrescriptionUrl: string = "/orion/prescription/removeUnsavedPrescription?consultationId=$consultationId";
// const savePatientPlanInDraftUrl: string = "/orion/plan/savePatientPlanInDraft";
// const getPatientPlanUrl: string = "/orion/plan/getPatientPlan?patientId=$patientId&secondaryUserId=$secondaryUserId&consultationId=$appointmentId&isSelf=$iSelfParam";
// const orionLoggerUrl: string = "/orion/client/logger";
// const fetchAdherenceUrl: string = "/orion/plan/adherence";
// const fetchAllMPPatientsForDoctor: string = "/orion/patientInfo/getMPPatientsForDoctor";
// const getOngoingConsultationDetailsUrl: string =
// 	"/orion/consultation/ongoing/fetch?patientId=$patientId&userId=$userId&appointmentId=$appointmentId&isSelf=$isSelfParam&isPresctionRequired=$isPresctionRequiredParam&isPackInfoRequired=$isPackInfoRequired";
// const getCoachOngoingConsultationDetailsUrl: string =
// 	"/orion/consultation/coach/ongoing/fetch?patientId=$patientId&userId=$userId&appointmentId=$appointmentId&isSelf=$isSelfParam&isPackInfoRequired=$isPackInfoRequired";
// const getEditConsultationDetailsUrl: string = "/orion/consultation/edit/fetch?patientId=$patientId&userId=$userId&appointmentId=$appointmentId&isSelf=$isSelfParam";
// const getEditLastConsultationDetailsUrl: string =
// 	"/orion/consultation/edit-last/fetch?patientId=$patientId&userId=$userId&appointmentId=$appointmentId&isSelf=$isSelfParam&isPackInfoRequired=$isPackInfoRequired";
// const savePatientPlanNewUrl: string = "/orion/consultation/ongoing/end";
// const savePatientPlanEditedUrl: string = "/orion/consultation/edit/end";
// const removeWorkflowObjectUrl: string = "/orion/consultation/ongoing/removeWorkflowObject";
// const patientLifestylePlanViewUrl: string = "/orion/patientInfo/lifestylePlanView";
// const staticDietRecallDataUrl: string = "/orion/static/fetch";
// const adherenceOverallScoresUrl: string = "/orion/patientInfo/adherence/overallScores";
// const updateAppointmentStatus: string = "/orion/consultation/update";
// const getUserVitalsData: string = "/orion/patientInfo/getUserVitalsData";
// const updatePatientPlanEligibilityMasks: string = "/orion/plan/updatePatientPlanEligibilityMasks";
// const deleteDiagnosticLabTests: string = "/orion/patientInfo/deletePatientLabTests";
// const requestPdfGeneration: string = "/orion/pdf/request-generation";
// const fetchPastConsultationDataForPatientUrl: string = "/orion/consultation/pastConsultationData";
// const getTreatmentPlanDetailsUrl: string = "/orion/consultation/treatmentPlan/fetch?doctorType=$doctorType";
// const getUserFormUrl: string = "/orion/userform/$formId?userId=$userId";
// const sendUserFormUrl: string = "/orion/userform/submit/$responseId?userId=$userId";
// const getAllowedAgentTypesForAutomatedWorkingHours = "/orion/automated-working-hours/allowed-agent-types";
// const logLogoutStatus = "/orion/utils/log";
// const fetchAllExercises = "/orion/v1/microcycle/exercises";
// const fetchLabeledAllExercises = "/orion/v1/microcycle/exercises-label?label=$label";
// const getDishesByDishIdsURL = "/orion/dish/dishes";
// const fetchBlogsForUltrafit = "/orion/sugarfit-cms/blog/ultrafit";
// const saveMedicinePrescription = "/orion/chs/medicine-prescription/save";
// const fetchMedicinePrescription = "/orion/chs/medicine-prescription/fetch?userId=$userId&referenceId=$referenceId&isDetailed=$isDetailed";
// const redisLifestyleRecallUrl = "/orion/patientInfo/redis/lifestyle-recall?consultationId=$consultationId";
// const getPrescriptionLabTestSuggestions = "/orion/client/lab-test/suggestions";
// const saveCoachConsultDataToRedisUrl = "/orion/consultation/coach-consult-draft";
// const deleteCoachConsultDataFromRedisUrl = "/orion/consultation/coach-consult-draft-delete?consultationId=$consultationId";
// const fetchPastPrescriptionsUrl = "/orion/consultation/past-prescriptions?patientId=$patientId&userId=$userId";
// const convertToAAC = "/orion/convertToAAC";
// export interface IAutoSavePrescriptionReq {
// 	id: number;
// 	prescription: IPrescription;
// }
//
// interface IConsultationDataResponse {
// 	caseSummary: string;
// 	medicalProfile: any;
// }

export default class InternalApis implements IInternalApis {
	getAccountData(): Promise<IAccountData> {
		return ApiUtils.get(InternalApiUrls.account)
	}
	//
	// getUserForm(formId: FormTypes, userId: string): Promise<UserFormData> {
	// 	return ApiUtils.apiGetRequest(ApiUtils.createApiUrl(getUserFormUrl.replace("$formId", formId)).replace("$userId", userId));
	// }
	//
	// sendFormData(formId: FormTypes, data: any, userId: string): Promise<any> {
	// 	const id = data._id;
	// 	return ApiUtils.apiPostRequest(sendUserFormUrl.replace("$responseId", id).replace("$userId", userId), JSON.stringify(data));
	// }
	//
	// getUnsavedPrescription(consultationId: number): Promise<IPrescription> {
	// 	return ApiUtils.apiGetRequest(ApiUtils.createApiUrl(unsavedPrescriptionUrl.replace(APPOINTMENT_ID_PARAM_CONST, consultationId.toString())));
	// }
	//
	// savePatientPlanInDraft(consultationId: number, patientPlan: IGenericPlanPrescriptionDetailObject[]): Promise<any> {
	// 	let req = { consultationId, patientPlan };
	// 	return ApiUtils.apiPostRequest(savePatientPlanInDraftUrl, JSON.stringify(req));
	// }
	//
	// getPatientPlan(patientId: number, secondaryUserId: string, consultationId: number, isSelf: boolean): Promise<IOrionPlanResponse> {
	// 	return ApiUtils.apiGetRequest(
	// 		ApiUtils.createApiUrl(
	// 			getPatientPlanUrl
	// 				.replace("$patientId", patientId.toString())
	// 				.replace("$secondaryUserId", secondaryUserId.toString())
	// 				.replace("$appointmentId", AppUtils.isDefined(consultationId) ? consultationId.toString() : null)
	// 		).replace("$iSelfParam", isSelf.toString())
	// 	);
	// }
	//
	// savePrescriptionInRedis(autoSavePrescriptionReq: IAutoSavePrescriptionReq): Promise<any> {
	// 	return ApiUtils.apiPostRequest(savePrescriptionUrl, JSON.stringify(autoSavePrescriptionReq));
	// }
	//
	// removePrescriptionFromRedis(consultationId: number): Promise<any> {
	// 	return ApiUtils.apiGetRequest(removePrescriptionUrl.replace(`$${CONSULTATION_ID_PARAM}`, consultationId.toString()));
	// }
	//
	getPlanStaticData(): Promise<IPlanStaticData> {
		return ApiUtils.get(InternalApiUrls.planStaticDataUrl)
	}
	//
	// getStaticDietRecallData(): Promise<any> {
	// 	return ApiUtils.apiGetRequest(staticDietRecallDataUrl);
	// }

	getAllStaticData(): Promise<Record<string, any>> {
		return ApiUtils.get(InternalApiUrls.staticData)
	}
	//
	// orionClientLogger(err: any): Promise<any> {
	// 	return ApiUtils.apiPostRequest(orionLoggerUrl, JSON.stringify(err));
	// }
	// getPatientAdherenceDetails(params: any): Promise<object> {
	// 	let currUrl = fetchAdherenceUrl + "?" + ApiUtils.requestToQueryParams(params);
	// 	return ApiUtils.apiGetRequest(currUrl);
	// }
	//
	// getAllMpPatientsForDoctor(doctorId: string, aggregateLevel: string, startEpoch: number, endEpoch: number): Promise<object> {
	// 	const params = ApiUtils.requestToQueryParams({ doctorId, aggregateLevel, startEpoch, endEpoch });
	// 	let url = `${fetchAllMPPatientsForDoctor}?${params}`;
	// 	return ApiUtils.apiGetRequest(url);
	// }
	//
	// getOngoingConsultationDetails(
	// 	patientId: number,
	// 	userId: number,
	// 	appointmentId: number,
	// 	isSelf: boolean,
	// 	isPresctionRequired?: boolean,
	// 	isPackInfoRequired?: boolean
	// ): Promise<IOngoingConsultation> {
	// 	return ApiUtils.apiGetRequest(
	// 		getOngoingConsultationDetailsUrl
	// 			.replace("$patientId", patientId.toString())
	// 			.replace("$userId", userId.toString())
	// 			.replace("$appointmentId", appointmentId.toString())
	// 			.replace("$isSelfParam", isSelf.toString())
	// 			.replace("$isPresctionRequiredParam", isPresctionRequired ? isPresctionRequired.toString() : "false")
	// 			.replace("$isPackInfoRequired", isPackInfoRequired.toString())
	// 	);
	// }
	//
	getCoachOngoingConsultationDetails(patientId: number, userId: number, appointmentId: number, isSelf: boolean, isPackInfoRequired?: boolean): Promise<any> {
		return ApiUtils.get(InternalApiUrls.coachOngoingConsultationDate(patientId, userId, appointmentId, isSelf, isPackInfoRequired), null, null, null, null, 10000)
	}
	//
	// getLastConsultationDetails(patientId: number, userId: number, appointmentId: number, isSelf: boolean, isPackInfoRequired?: boolean): Promise<IOngoingConsultation> {
	// 	return ApiUtils.apiGetRequest(
	// 		getEditLastConsultationDetailsUrl
	// 			.replace("$patientId", patientId.toString())
	// 			.replace("$userId", userId.toString())
	// 			.replace("$appointmentId", appointmentId.toString())
	// 			.replace("$isSelfParam", isSelf.toString())
	// 			.replace("$isPackInfoRequired", isPackInfoRequired.toString())
	// 	);
	// }
	//
	// getEditConsultationDetails(patientId: number, userId: number, appointmentId: number, isSelf: boolean): Promise<IEditConsultationResponse> {
	// 	return ApiUtils.apiGetRequest(
	// 		getEditConsultationDetailsUrl
	// 			.replace("$patientId", patientId.toString())
	// 			.replace("$userId", userId.toString())
	// 			.replace("$appointmentId", appointmentId.toString())
	// 			.replace("$isSelfParam", isSelf.toString())
	// 	);
	// }
	//
	// getEditOutsideConsultationDetails(patientId: number, appointmentId: number): Promise<IEditOutsideConsultationResponse> {
	// 	return ApiUtils.apiGetRequest(getEditConsultationDetailsUrl.replace("$patientId", patientId.toString()).replace("$appointmentId", appointmentId.toString()));
	// }
	//
	// getTreatmentPlanDetails(doctorType: string): Promise<any> {
	// 	return ApiUtils.apiGetRequest(getTreatmentPlanDetailsUrl.replace("$doctorType", doctorType));
	// }
	//
	// savePatientPlanNew(
	// 	consultation: IAppointmentScheduleResponse,
	// 	prescription: IPrescription,
	// 	patientPlan: IPatientLifestylePlanWrapper,
	// 	planId: string,
	// 	status: ConsultationStatusConstant,
	// 	isSelf: boolean,
	// 	medicalProfile?: any
	// ): Promise<any> {
	// 	let req = { consultation, prescription, patientPlan, planId, status, isSelf, medicalProfile };
	// 	return ApiUtils.apiPostRequest(savePatientPlanNewUrl, JSON.stringify(req));
	// }
	//
	// savePatientPlanEdited(
	// 	consultation: IAppointmentScheduleResponse,
	// 	patientPlan: IPatientLifestylePlanWrapper,
	// 	planId: string,
	// 	status: ConsultationStatusConstant,
	// 	isSelf: boolean,
	// 	medicalProfile?: any
	// ): Promise<any> {
	// 	let req = { consultation, patientPlan, planId, status, isSelf, medicalProfile };
	// 	return ApiUtils.apiPostRequest(savePatientPlanEditedUrl, JSON.stringify(req));
	// }
	//
	// removePlanWorkflowObject(consultation: IAppointmentScheduleResponse, isPrescriptionObject: boolean): Promise<any> {
	// 	let req = { consultation, isPrescriptionObject };
	// 	return ApiUtils.apiPostRequest(removeWorkflowObjectUrl, JSON.stringify(req));
	// }
	//
	// getPatientLifestylePlanView(secondaryUserId: string, consultationId: number): Promise<any> {
	// 	let params = ApiUtils.requestToQueryParams({ secondaryUserId, consultationId });
	// 	return ApiUtils.apiGetRequest(`${patientLifestylePlanViewUrl}?${params}`);
	// }
	//
	// getPatientsOverallAdherenceScores(aggregateLevel: string, startEpoch: number, endEpoch: number, userIds: string): Promise<any> {
	// 	let params = ApiUtils.requestToQueryParams({ aggregateLevel, startEpoch, endEpoch, userIds });
	// 	return ApiUtils.apiGetRequest(`${adherenceOverallScoresUrl}?${params}`);
	// }
	//
	// updateAppointmentStatus(bookingId: number, appointmentId: number, status: string, dietPlanChanged: boolean): Promise<any> {
	// 	let params = ApiUtils.requestToQueryParams({ bookingId, appointmentId, status, dietPlanChanged });
	// 	return ApiUtils.apiGetRequest(`${updateAppointmentStatus}?${params}`);
	// }
	//
	getCurrentTime(): Promise<any> {
		return ApiUtils.get(InternalApiUrls.getCurrentTime)
	}

	fetchUserVitalsDataFromMetricService(userId: number, patientId: number, metricIds: number[], metricNamesToFetchMetrics?: string[]): Promise<IPatientVital[]> {
		const url = InternalApiUrls.patientVitals(userId, patientId, metricIds) + `&metricNames=${metricNamesToFetchMetrics?.join(",")}`;
		return ApiUtils.get(url, null, null, null, null, 10000)
	}
	// updatePatientPlanEligibilityMasks(userId: String, secondaryUserId: String, isSelf: Boolean, eligibilityMasks: String[]): Promise<any> {
	// 	let params = ApiUtils.requestToQueryParams({ userId, secondaryUserId, isSelf });
	// 	let req = { eligibilityMasks };
	// 	return ApiUtils.apiPostRequest(`${updatePatientPlanEligibilityMasks}?${params}`, JSON.stringify(req));
	// }
	// deletePatientDiagnosticLabTests(labTestIds: number[]): Promise<any> {
	// 	return ApiUtils.apiDeleteRequest(deleteDiagnosticLabTests, JSON.stringify({ labTestIds: labTestIds }));
	// }
	requestPdfGeneration(html: string, status: ConsultationStatusConstant, bookingId: number, consultationId: number, sigUrl: string, isInCenterPdf?: boolean): Promise<any> {
		return ApiUtils.post(InternalApiUrls.requestPdfGeneration, {
			html,
			status,
			bookingId,
			consultationId,
			sigUrl,
			isInCenterPdf,
		})
	}

	requestCgmReportPdfGeneration(html: string, userId: number, deviceId: string, pageHeight: number): Promise<any> {
		return ApiUtils.post(InternalApiUrls.requestCgmReportPdfGeneration, {
			html,
			userId,
			deviceId,
			pageHeight,
		})
	}
	//
	// fetchPastConsultationDataForPatient(consultationId: string, doctorType: string, patientId: string, userId: string): Promise<IConsultationDataResponse> {
	// 	const queryParams = ApiUtils.requestToQueryParams({
	// 		consultationId,
	// 		doctorType,
	// 		patientId,
	// 		userId,
	// 	});
	// 	return ApiUtils.apiGetRequest(`${fetchPastConsultationDataForPatientUrl}?${queryParams}`);
	// }
	//
	// getAllowedAgentTypesForAutomatedWorkingHours() {
	// 	return ApiUtils.apiGetRequest(getAllowedAgentTypesForAutomatedWorkingHours);
	// }
	//
	// logLogoutStatus(details: string) {
	// 	return ApiUtils.apiPostRequest(logLogoutStatus, details);
	// }
	//
	// fetchAllExercises() {
	// 	return ApiUtils.apiGetRequest(fetchAllExercises);
	// }
	//
	// fetchLabeledAllExercises(label: string) {
	// 	return ApiUtils.apiGetRequest(fetchLabeledAllExercises.replace("$label", label));
	// }
	//
	// fetchDishesByDishIds(dishIds: string[]): Promise<IDish[]> {
	// 	return ApiUtils.apiPostRequest(getDishesByDishIdsURL, JSON.stringify({ dishIds }));
	// }
	//
	getMembershipsForUser(userId: string, userIdType?: string): Promise<WatchmenMembership[]> {
		return ApiUtils.get(InternalApiUrls.getMembershipsForUser(userId, userIdType))
	}
	//
	// fetchBlogsForUltrafit(): Promise<BlogCatalog[]> {
	// 	return ApiUtils.apiGetRequest(fetchBlogsForUltrafit);
	// }
	//
	// saveMedicinePrescription(userId: number, configBasedPrescription: IConfigBasedPrescription, appointmentId: number) {
	// 	const {
	// 		newConfigData: { prescriptionMedicines },
	// 	} = EHRRequestMapper.getEHRSavePrescriptionRequestFromConfigBasedPrescription(configBasedPrescription);
	// 	return ApiUtils.apiPostRequest(saveMedicinePrescription, JSON.stringify({ userId, appointmentId, prescriptionMedicines }));
	// }
	//
	// fetchMedicinePrescription(userId: string, referenceId: string, isDetailed: boolean = true) {
	// 	return ApiUtils.apiGetRequest(fetchMedicinePrescription.replace("$userId", userId).replace("$referenceId", referenceId).replace("$isDetailed", String(isDetailed)));
	// }
	//
	// saveLifestyleRecallToRedis(consultationId: string, lifestyleRecallPlan: any) {
	// 	return ApiUtils.apiPostRequest(redisLifestyleRecallUrl.replace("$consultationId", consultationId), JSON.stringify({ lifestyleRecallPlan }));
	// }
	//
	// fetchLifestyleRecallToRedis(consultationId: string) {
	// 	return ApiUtils.apiGetRequest(redisLifestyleRecallUrl.replace("$consultationId", consultationId));
	// }
	//
	// fetchPrescriptionLabTestSuggestions() {
	// 	return ApiUtils.apiGetRequest(getPrescriptionLabTestSuggestions);
	// }
	//
	saveCoachConsultDataToRedis(consultationId: number, payload: Partial<ICoachConsultation>) {
		return ApiUtils.post(InternalApiUrls.saveCoachConsultationDataToRedis, { consultationId, payload })
	}

	deleteCoachConsultDataFromRedis(consultationId: number) {
		return ApiUtils.get(InternalApiUrls.deleteCachedCoachConsultationData(consultationId))
	}

	fetchPastPrescriptions(patientId: number, userId: number) {
		return ApiUtils.get(InternalApiUrls.fetchPastPrescriptions(patientId, userId))
	}

	// convertToAAC(data: any): any {
	// 	return ApiUtils.apiPutRequest(convertToAAC, JSON.stringify(data));
	// }

	saveDoctorOngoingConsultationDataToRedis = (appointmentId: number, payload: Partial<IOngoingDoctorConsultation>) => {
		return ApiUtils.post(InternalApiUrls.doctorOngoingConsultationData(appointmentId), payload)
	}
	fetchDoctorOngoingConsultationDataFromRedis = (appointmentId: number) => {
		return ApiUtils.get(InternalApiUrls.doctorOngoingConsultationData(appointmentId))
	}

	getAppVersion = () => {
		return ApiUtils.get(InternalApiUrls.getCurrentVersion, {}, "", false)
	}

	uploadMediaChunk = (formDataReq: Record<string, any>) => {
		return ApiUtils.apiFormDataPostRequest(InternalApiUrls.uploadMediaChunk, formDataReq)
	}

	downloadAndUploadFile = (downloadUrl: string, uploadUrl: string): Promise<any> => {
		return ApiUtils.post(InternalApiUrls.downloadAndUploadFile, { downloadUrl, uploadUrl })
	}

	createCachedOdinTicket = (payload: ICreateCachedOdinTicketPayload): Promise<ICreateCachedOdinTicketResponse> => {
		return ApiUtils.post(InternalApiUrls.createCachedOdinTicket, payload)
	}
}
